import React, { useEffect, useState } from "react";
import { Grid2 } from "@mui/material";
import { useSetState } from "Utils/Helpers/Hooks";
import Inputer from "Utils/Helpers/Inputer";
import MButton from "Utils/Helpers/MButton";
import { useDispatch, useSelector } from "react-redux";
import { HandleLoading } from "Utils/Helpers/ApiServices";
import { enqueueSnackbar } from "notistack";
import CheckApiStatus from "Utils/Constants/CheckApiStatus";
import { put_character_description } from "http/components/Characters";
import { get_site_data, post_site_data } from "http/components/SiteData";

export default function ManagePageDescription() {
  const dispatch = useDispatch();
  const [data, setData] = useState(null);
  const [controls, setControls] = useSetState({
    title_en: {
      label: "Title (en)",
      type: "text",
      multiLine: false,
      placeholder: "Title (en)",
      value: "",
      validation: false,
    },
    description_en: {
      label: "Description (en)",
      type: "text",
      multiLine: true,
      placeholder: "Description (en)",
      value: "",
      validation: false,
    },
    title_fr: {
      label: "Title (fr)",
      type: "text",
      multiLine: false,
      placeholder: "Title (fr)",
      value: "",
      validation: false,
    },
    description_fr: {
      label: "Description (fr)",
      type: "text",
      multiLine: true,
      placeholder: "Description (fr)",
      value: "",
      validation: false,
    },
    title_it: {
      label: "Title (it)",
      type: "text",
      multiLine: false,
      placeholder: "Title (it)",
      value: "",
      validation: false,
    },
    description_it: {
      label: "Description (it)",
      type: "text",
      multiLine: true,
      placeholder: "Description (it)",
      value: "",
      validation: false,
    },
  });

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    dispatch(HandleLoading(true));
    const response = await get_site_data(92631);
    if (CheckApiStatus(response)) setData(response.data.infos);
    dispatch(HandleLoading(false));
  };

  useEffect(() => {
    if (data && data.length !== 0) {
      data[0].languages.map((items) => {
        setControls({
          [`title_${items.language}`]: { value: items.title, validation: true },
        });
        setControls({
          [`description_${items.language}`]: {
            value: items.body,
            validation: true,
          },
        });
      });
    }
  }, [data]);

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value, validation } });
  };

  const onCreate = async () => {
    dispatch(HandleLoading(true));
    const response = await post_site_data({
      title: "create",
      body: "create",
      section: "characters",
    });
    if (CheckApiStatus(response)) {
      await getData();
      enqueueSnackbar("Insert Success", { variant: "success" });
    }
    dispatch(HandleLoading(false));
  };

  const onSubmit = async () => {
    const {
      title_en,
      title_fr,
      title_it,
      description_en,
      description_fr,
      description_it,
    } = controls;
    if ((title_en.value !== "", title_fr.value !== "", title_it.value !== "")) {
      dispatch(HandleLoading(true));
      const response = await put_character_description({
        title: JSON.stringify({
          en: title_en.value,
          fr: title_fr.value,
          it: title_it.value,
        }),
        description: JSON.stringify({
          en: description_en.value ? description_en.value : "",
          fr: description_fr.value ? description_fr.value : "",
          it: description_it.value ? description_it.value : "",
        }),
      });
      if (CheckApiStatus(response)) {
        await getData();
        enqueueSnackbar("Edit Success", { variant: "success" });
      }
      dispatch(HandleLoading(false));
    } else {
      enqueueSnackbar("Enter data correctly", { variant: "error" });
    }
  };

  return (
    <Grid2 container spacing={2}>
      {!data ? (
        <p>Loading ...</p>
      ) : data.length === 0 ? (
        <Grid2 size={{ xs: 12 }}>
          <MButton
            label={"Create page description"}
            onClick={onCreate}
          />
        </Grid2>
      ) : (
        <>
          {Object.keys(controls).map((key, index) => {
            return (
              <Grid2
                size={{ sm: key.includes("title") ? 4 : 8, xs: 12 }}
                key={key + index}
              >
                <Inputer
                  id={key}
                  setValue={setValue.bind(this)}
                  value={controls[key].value}
                  label={controls[key].label}
                  placeholder={controls[key].placeholder}
                  type={controls[key].type}
                  multiLine={controls[key].multiLine}
                />
              </Grid2>
            );
          })}
          <Grid2 size={{ xs: 12 }}>
            <MButton label={"Save"} onClick={onSubmit} />
          </Grid2>
        </>
      )}
    </Grid2>
  );
}
